import dynamic from 'next/dynamic';

import { Author } from '@natu/ui/Author';

import { getAssetFromStoryblok, type StoryblokAsset } from '../../../../utils';

const ResponsiveImage = dynamic(() =>
  import('@natu/ui/ResponsiveImage').then(mod => mod.ResponsiveImage),
);

export interface TestimonialItem {
  _uid: string;
  priority?: boolean;
  imageMobile?: StoryblokAsset;
  imageDesktop?: StoryblokAsset;
  name?: string;
  role?: string;
  testimonial?: string;
}

export interface SBCarouselTestimonialItemProps {
  item?: TestimonialItem;
}

export const SBCarouselTestimonialItem = ({ item }: SBCarouselTestimonialItemProps) => {
  const { priority, imageMobile, imageDesktop, name, role, testimonial, ...rest } = item || {};

  const imageMobileData = getAssetFromStoryblok(imageMobile);
  const imageDesktopData = getAssetFromStoryblok(imageDesktop);

  return (
    <div className="relative h-full lg:pl-16" {...rest}>
      {imageDesktopData?.src && (
        <ResponsiveImage
          className="hidden w-full lg:block"
          priority={priority}
          {...imageDesktopData}
        />
      )}
      <div className="h-full rounded-xl rounded-tr-[44px] bg-white p-6 pb-14 lg:absolute lg:bottom-2 lg:left-0 lg:h-auto lg:w-11/12 lg:pb-8 xl:bottom-8 xl:w-[calc(100%-104px)] xl:pb-14">
        <Author className="mb-4" variant="hero" image={imageMobileData} name={name} role={role} />
        <p className="text-base md:text-lg lg:text-sm xl:text-lg">{testimonial}</p>
      </div>
    </div>
  );
};
